import controller from './permissions.controller';

const template = require('./permissions.html');

export default {
    bindings: {
        owner: '<',
        users: '<',
        isEditing: '<'
    },
    template,
    controller
};



// WEBPACK FOOTER //
// ./app/components/sensors-and-connectors/components/thing-details/permissions/permissions.component.js